import React, { useCallback, memo } from 'react';
import { TableRow } from 'semantic-ui-react';
import { Text } from '@cuemath/web-comps';

import { TableCell } from 'comps';

import { DETECTION_TYPES_CONFIG, REVIEW_STATUS_CONFIG } from 'constants/av-review';
import { ROW_STYLE } from '../../constants';
import { DetectionsWrapper, Badge } from './review-row-styled';

const ReviewRow = memo(({ review, isAdmin, onRowClick }) => {
  const handleClick = useCallback(() => onRowClick(review.id), [review.id, onRowClick]);
  const statusConfig = REVIEW_STATUS_CONFIG[review.status];

  return (
    <TableRow style={ROW_STYLE} onClick={handleClick}>
      {isAdmin && <TableCell width={2}>{review.reviewerId}</TableCell>}
      <TableCell width={2}>{review.classroomId}</TableCell>
      <TableCell width={2}>{review.teacherId}</TableCell>
      <TableCell width={1}>{review.classType}</TableCell>
      <TableCell width={1}>{review.sessionDate}</TableCell>
      <TableCell width={3}>
        <DetectionsWrapper flexDirection="row" alignItems="center">
          {review.detections.map(detection => {
            const config = DETECTION_TYPES_CONFIG[detection.type] || {};
            return (
              <Badge key={detection.type} bgColor={config.bgColor} padding="2px 8px" flexDirection="row" alignItems="center">
                <Text variant="body3" color={config.color}>
                  {detection.label} &times; {detection.count}
                </Text>
              </Badge>
            );
          })}
        </DetectionsWrapper>
      </TableCell>
      <TableCell width={1}>
        {review.status && statusConfig && (
          <Badge bgColor={statusConfig.bgColor} padding="4px 12px" flexDirection="row" alignItems="center">
            <Text variant="body3" color={statusConfig.color}>
              {statusConfig.label}
            </Text>
          </Badge>
        )}
      </TableCell>
    </TableRow>
  );
});

export default ReviewRow;
